import RegisterForm from './components/RegisterForm';
import SplashScreen from '../../features/auth/components/SplashScreen/SplashScreen';
import useIsMobileView from '../../hooks/useIsMobileView';
import Modal from '@/components/Modal/Modal';
import HeaderMobileDisplay from '@/components/header/views/HeaderMobileDisplay';

const Register = () => {
  const isMobileView = useIsMobileView();

  if (isMobileView) {
    return (
      <div className="text-[16px]">
        <HeaderMobileDisplay.Container className="justify-center">
          <HeaderMobileDisplay.Logo />
        </HeaderMobileDisplay.Container>
        <div className="h-full p-4">
          <RegisterForm />
        </div>
      </div>
    );
  }

  return (
    <SplashScreen>
      <Modal open={true} bodyClassName="flex justify-center">
        <RegisterForm />
      </Modal>
    </SplashScreen>
  );
};

export default Register;
